import type { Drag } from '../../directives/draggable.directive';

export class SwipeDetector {
  start: {
    x: number;
    y: number;
    timestamp: number;
    direction: 'top' | 'right' | 'bottom' | 'left' | 'none';
  };
  current: { x: number; y: number; timestamp: number };

  constructor(
    private onSwipe: (direction: 'top' | 'right' | 'bottom' | 'left') => void
  ) {}

  move(drag: Drag) {
    if (!this.start) {
      this.start = {
        ...drag.current,
        timestamp: drag.event.timeStamp,
        direction: 'none',
      };
    } else {
      const previousPos = {
        x: this.current?.x ?? this.start?.x ?? 0,
        y: this.current?.y ?? this.start?.y ?? 0,
      };
      const direction = this.getDirection(previousPos, drag.current);

      if (this.start.direction === 'none') {
        this.start = { ...this.start, direction };
      } else if (this.start.direction !== direction) {
        this.start = undefined;
        this.current = undefined;

        return this.move(drag);
      }

      this.current = { ...drag.current, timestamp: drag.event.timeStamp };
    }
  }

  release(drag: Drag) {
    if (
      this.start &&
        this.start.direction !== 'none' &&
        this.isSwipe(drag.event)
    ) {
      this.onSwipe(this.start.direction);

      this.start = undefined;
      this.current = undefined;

      return true;
    }

    return false;
  }

  private isSwipe(event: PointerEvent | MouseEvent | TouchEvent) {
    const dt = this.current.timestamp - this.start.timestamp;
    const sensitivity =
        event instanceof TouchEvent ||
        (event instanceof PointerEvent && event.pointerType !== 'mouse')
          ? 0.5
          : 4;
    if (this.start.direction === 'left' || this.start.direction === 'right') {
      const dx = Math.abs(this.current.x - this.start.x);

      if (dx > dt * sensitivity) {
        return true;
      }
    } else if (
      this.start.direction === 'top' ||
        this.start.direction === 'bottom'
    ) {
      const dy = Math.abs(this.current.y - this.start.y);

      if (dy > dt * sensitivity) {
        return true;
      }
    }

    return false;
  }

  private getDirection(
    pos1: { x: number; y: number },
    pos2: { x: number; y: number }
  ): 'top' | 'right' | 'bottom' | 'left' | 'none' {
    const dx = pos2.x - pos1.x;
    const dy = pos2.y - pos1.y;

    if (Math.abs(dx) > Math.abs(dy)) {
      return dx > 0 ? 'right' : 'left';
    } else {
      return dy > 0 ? 'bottom' : 'top';
    }
  }
}

